// Picture tiles (Liam, 23 Oct 2026, picking design D for Not done: "this is much better than the first attempt"): a
// drawn line picture on a tile, the customer's initials in a lemon circle. The style kit's picture layer
// (docs/brand/README.md, Picture tiles); drawn like the send buttons' icons (contact-ui.ts wayIcon), 24 by 24.

const CALENDAR = ['M5 5h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z', 'M3 10h18M8 3v4M16 3v4']
const PERSON = ['M5 8a4 4 0 1 0 8 0a4 4 0 1 0-8 0', 'M2 21a7 7 0 0 1 14 0']

const DRAWINGS = {
  panels: ['M4 4h16v16H4z', 'M12 4v16M4 12h16'],
  roofWindows: ['M3 18L9 4h12l-6 14z', 'M6 11h12M15 4L9 18'],
  frames: ['M5 3h14v17H5z', 'M3 21h18M5 16h14'],
  fascias: ['M2 9l10-6 10 6', 'M4 9v4h16V9'],
  gutters: ['M3 8h18l-2 4H5z', 'M7 12v8M17 12v8'],
  roof: ['M3 12l9-7 9 7', 'M5 10v10h14V10M9 20v-6h6v6'],
  time: ['M3 12a9 9 0 1 0 18 0a9 9 0 1 0-18 0', 'M12 7v5l3.2 2'],
  door: ['M7.5 3h9A1.5 1.5 0 0 1 18 4.5v15a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 19.5v-15A1.5 1.5 0 0 1 7.5 3z', 'M13.5 12a1 1 0 1 0 2 0a1 1 0 1 0-2 0'],
  lock: ['M7 11h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2z', 'M8 11V7a4 4 0 0 1 8 0v4'],
  rain: ['M7 16a4 4 0 1 1 1-7.9A5 5 0 0 1 17.6 9 3.5 3.5 0 0 1 17 16H7z', 'M9 19l-1 2M13 19l-1 2M17 19l-1 2'],
  personCross: [...PERSON, 'M17 8l5 5M22 8l-5 5'],
  pencil: ['M12 20h9', 'M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z'],
  calendarMove: [...CALENDAR, 'M9 15.5h6M13 13.5l2 2-2 2'],
  again: ['M21 4v6h-6', 'M20 15a8 8 0 1 1-2-8.5L21 10'],
  calendarCross: [...CALENDAR, 'M10 13.5l4 4M14 13.5l-4 4'],
  personOff: [...PERSON, 'M16 11h6'],
  // Old customers' bin (26 Oct 2026).
  // Your business's Google reviews card (26 Oct 2026).
  star: ['M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1-4.4-4.3 6.1-.9z'],
  bin: ['M4 7h16M9 7V4h6v3', 'M6 7l1 13h10l1-13M10 11v6M14 11v6'],
  // Plan the round's list tiles (Liam, 23 Oct 2026, design A).
  people: ['M6 8a3 3 0 1 0 6 0a3 3 0 1 0-6 0', 'M3 20a6 6 0 0 1 12 0', 'M16 5a3 3 0 0 1 0 6M18 20a6 6 0 0 0-3-5.2'],
  calendarTick: [...CALENDAR, 'M9 15l2 2 4-4'],
  snowflake: ['M12 3v18M4.2 7.5l15.6 9M19.8 7.5l-15.6 9', 'M9.5 4.5L12 7l2.5-2.5M9.5 19.5L12 17l2.5 2.5'],
  house: ['M3 11l9-7 9 7v9a1 1 0 0 1-1 1h-5v-6h-6v6H4a1 1 0 0 1-1-1z'],
  priceTag: ['M3 3h8l10 10-8 8L3 11z', 'M7.5 7.5h.01'],
  dots: ['M4 12a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0-3 0M10.5 12a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0-3 0M17 12a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0-3 0'],
  // History's changes, by kind (design A, 23 Oct 2026).
  tick: ['M5 12.5l4.5 4.5L19 7.5'],
  pound: ['M16 6.5A3.5 3.5 0 0 0 9.5 8v12M7 13h7M6 20h12'],
  // Today's tiles (design B, 24 Oct 2026): the stops left on a map, and Finish my day.
  pin: ['M12 21s7-5.6 7-11a7 7 0 1 0-14 0c0 5.4 7 11 7 11z', 'M9.5 10a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0-5 0'],
  flag: ['M5 21V4', 'M5 4h12l-2.5 4 2.5 4H5'],
  calendar: [...CALENDAR],
  calendarPlus: [...CALENDAR, 'M12 13v5M9.5 15.5h5'],
  person: ['M8 8a4 4 0 1 0 8 0a4 4 0 1 0-8 0', 'M5 21a7 7 0 0 1 14 0'],
  personPlus: [...PERSON, 'M19 8v6M16 11h6'],
  note: ['M6 3h9l4 4v14H6z', 'M9 11h7M9 15h7M9 7h3'],
  camera: ['M4 8h3l2-3h6l2 3h3v11H4z', 'M9 13a3 3 0 1 0 6 0a3 3 0 1 0-6 0'],
  list: ['M9 6h11M9 12h11M9 18h11', 'M4.5 6h.01M4.5 12h.01M4.5 18h.01'],
  toggle: ['M7 7h10a5 5 0 0 1 0 10H7A5 5 0 0 1 7 7z', 'M14 12a3 3 0 1 0 6 0a3 3 0 1 0-6 0'],
  chevronRight: ['M9 6l6 6-6 6'],
  chevronLeft: ['M15 6l-6 6 6 6'],
  // Today's Focus mode (24 Oct 2026): one stop at a time.
  focus: ['M3 12a9 9 0 1 0 18 0a9 9 0 1 0-18 0', 'M9.5 12a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0-5 0'],
  chevronDown: ['M6 9l6 6 6-6'],
  chevronUp: ['M6 15l6-6 6 6'],
  search: ['M4 11a7 7 0 1 0 14 0a7 7 0 1 0-14 0', 'M20 20l-4-4'],
  info: ['M3 12a9 9 0 1 0 18 0a9 9 0 1 0-18 0', 'M12 11v5M12 8h.01'],
  // Owed's tiles (design B, 23 Oct 2026).
  bubble: ['M4 5h16v11H9l-5 4z'],
  hourglass: ['M7 3h10M7 21h10', 'M8 3c0 5 8 5 8 9s-8 4-8 9M16 3c0 5-8 5-8 9s8 4 8 9'],
  phone: ['M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2'],
  question: ['M3 12a9 9 0 1 0 18 0a9 9 0 1 0-18 0', 'M9.5 9a2.5 2.5 0 1 1 3.5 2.3c-.6.3-1 .9-1 1.7M12 17h.01'],
  bank: ['M3 10h18L12 4z', 'M6 10v8M10 10v8M14 10v8M18 10v8M3 20h18'],
  arrowUp: ['M12 19V5M6 11l6-6 6 6'],
  arrowDown: ['M12 5v14M6 13l6 6 6-6'],
  // Follow up on an enquiry, as big tiles (Liam, 25 Oct 2026, "I sent them a quote", design B).
  quote: ['M7 3h7l5 5v13H7z', 'M14 3v5h5', 'M10 13h6M10 17h4'],
  reply: ['M21 11.5a8.5 8.5 0 0 1-12.6 7.4L3 21l2.1-5.4A8.5 8.5 0 1 1 21 11.5z'],
  send: ['M21 3 10 14', 'M21 3l-6.5 18-4.5-7-7-4.5z'],
  bubbleTick: ['M4 5h16v11H9l-5 4z', 'M8.5 10.5l2.5 2.5 4.5-4.5'],
  alarm: ['M12 21a8 8 0 1 0 0-16a8 8 0 0 0 0 16z', 'M12 9v4l2.5 2', 'M5 3 2 6M19 3l3 3'],
  arrowRight: ['M5 12h14', 'M13 6l6 6-6 6'],
  // Invoice details saved, What next? (Liam, 25 Oct 2026, design B).
  invoiceAdd: ['M6 3h9l4 4v14H6z', 'M15 3v4h4', 'M12.5 11v6M9.5 14h6'],
  invoice: ['M6 3h9l4 4v14H6z', 'M15 3v4h4', 'M9 12h7M9 16h5'],
  navigate: ['M3 11l18-8-8 18-2-8z'],
  car: ['M5 16h14v-4l-2-5H7l-2 5z', 'M7 19a1.5 1.5 0 1 0 0-3a1.5 1.5 0 1 0 0 3M17 19a1.5 1.5 0 1 0 0-3a1.5 1.5 0 1 0 0 3'],
  eye: ['M2 12s3.5-6.5 10-6.5S22 12 22 12s-3.5 6.5-10 6.5S2 12 2 12z', 'M9 12a3 3 0 1 0 6 0a3 3 0 1 0-6 0'],
  // Book again's close disc (0094, 28 Oct 2026): the kit's drawn cross.
  cross: ['M6 6l12 12M18 6L6 18'],
} satisfies Record<string, string[]>
export type Drawing = keyof typeof DRAWINGS

// Couldn't do it's answers (ui.ts BLOCKED_CHOICES) and their pictures; a reason without one is drawn as Other.
const REASON_DRAWINGS: Record<string, Drawing> = { time: 'time', not_in: 'door', no_access: 'lock', weather: 'rain', customer_cancelled: 'personCross', other: 'pencil' }
export const reasonDrawing = (code: string): Drawing => REASON_DRAWINGS[code] ?? 'pencil'

export function lineDrawing(name: Drawing, size = 22): SVGElement {
  const ns = 'http://www.w3.org/2000/svg'
  const svg = document.createElementNS(ns, 'svg')
  svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('width', String(size)); svg.setAttribute('height', String(size)); svg.setAttribute('aria-hidden', 'true')
  svg.setAttribute('class', 'pic-drawing')
  for (const d of DRAWINGS[name]) {
    const path = document.createElementNS(ns, 'path')
    path.setAttribute('d', d)
    path.setAttribute('fill', 'none'); path.setAttribute('stroke', 'currentColor'); path.setAttribute('stroke-width', '2'); path.setAttribute('stroke-linecap', 'round'); path.setAttribute('stroke-linejoin', 'round')
    svg.append(path)
  }
  return svg
}

// "Sid Carter" is SC, "Sid" is S, no name is ?.
export function initialsOf(name: string): string {
  // Letters only: "Zahda (saeed)" is ZS, never "Z(" (Liam's screenshot, 3 Nov 2026).
  const parts = name.trim().split(/\s+/).map((w) => w.replace(/^[^\p{L}\p{N}]+/u, '')).filter(Boolean)
  return ((parts[0]?.[0] ?? '') + (parts.length > 1 ? parts[parts.length - 1][0] : '')).toUpperCase() || '?'
}
